// import store from "store";
import Cookies from "js-cookie";
import Vue from "vue";
export function setCol(name, val) {
  return Cookies.set(name, val);
}
export function getCol(name) {
  return Cookies.get(name);
}
Vue.prototype.setCol = setCol;
Vue.prototype.getCol = getCol;
